import React, { Component } from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import * as actions from '../actions';
import * as selectors from '../selectors';
import LocationEdit from './LocationEdit';

class LocationEditContainer extends Component {
  componentDidMount() {
    if (this.props.id !== null) {
      this.props.fetchLocationsIfNeeded();
    }
    this.props.setActive(this.props.id);
  }

  handleSubmit = async values => {
    const { location, history, submitLocationEdit } = this.props;
    await submitLocationEdit({ ...location, ...values }, history);
    this.props.onComplete();
  };

  render() {
    const { ui } = this.props;
    let props = {
      onSubmit: this.handleSubmit,
      onCancel: this.props.onCancel,
      isLoading: ui.get('isLoading'),
      isError: ui.get('isError'),
      errorMessage: ui.get('errorMessage')
    };

    if (this.props.id !== null && this.props.location === null) {
      // Haven't loaded the requested location yet, bail out
      return null;
    }

    if (this.props.location !== null) {
      props.initialValues = this.props.location;
    }

    return <LocationEdit {...props} />;
  }
}

const mapStateToProps = createStructuredSelector({
  location: selectors.getActive,
  ui: selectors.getUI
});

export default connect(mapStateToProps, actions)(LocationEditContainer);



// WEBPACK FOOTER //
// ./src/modules/locations/components/LocationEditContainer.js